import React from "react";
import { Row, Col } from "antd";
import I18n, { fromSyntax } from "../../../i18n";
import { Metrics } from "../../../theme/";
import { DataVisualizeKeys } from "../../../theme/Colors";
import GraphConstant from "../../../constants/graph";
import Chart from "../../chart/";
import GraphCard from "../GraphCard";
import { MathUtil, isFunction, isAlive, isFillAlive } from "../../../util";
import DataPercentList from "../../list/DataPercentList";
import { GraphDataMaker } from "../../../util/helper/graph";
import GenericGraphDrawer from "../generics";

const createLevelValuePairObject = (data, isShort)=>{
	if(data === undefined){
		return undefined;
	}
	const format = I18n.t(isShort ? "level_format" : "stress_level_format");
	const objs = {};
	data.forEach((element, level) => {
		objs[fromSyntax(format, {level, detail: GraphConstant.RISK[level].short})] = element;
	});
	return objs;
};
export default (props)=>{
	const { short, data, previousData, onClick } = props;
	const mutateData = GraphDataMaker.createStressLevelArray(data);
	const previousMutateData = previousData ? GraphDataMaker.createStressLevelArray(previousData) : undefined;
	return (<GenericGraphDrawer.ReportColumnChart
		{...props}
		graphTextKey='short'
		onClickDataKey='level'
		data={mutateData}
		previousData={previousMutateData}
		removeZero={false}
		onClick={(level)=>{
			if(isAlive(onClick)){
				onClick(mutateData[level]);
			}
		}}
	/>);
};


// WEBPACK FOOTER //
// ./src/components/report/stress/StressLevel.js